<template>
  <div>
    <b-modal
      id="uchicago-summer-modal"
      ref="modal"
      size="lg"
      hide-header
      hide-footer
    >
      <div class="py-3">
        <h4 class="text-center">
          Have a wonderful summer and thank you for using Blue Crates!
        </h4>

        <div class="p-4 mb-3 border-dark border-opacity-25 rounded-2 bg-light">
          For those of you returning to campus housing this fall we will be coordinating fall
          deliveries with university housing. There is NO need to reach out to Blue Crates with
          your fall room assignment and address. Housing and Residence Life will provide that
          for us so you do not have to. For those of you not living in campus housing this fall
          and are moving off campus, please reach out to coordinate and schedule your delivery via
          <a href="mailto:uchicago@bluecrates.com">uchicago@bluecrates.com</a>
          .
        </div>

        <div class="text-center">
          <button
            class="btn btn-primary"
            @click="handleContinueClicked"
          >
            Continue
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { BModal } from "bootstrap-vue";

@Component({
})
export default class UChicagoSummerModal extends Vue {
  $refs!: {
    modal: BModal | any
  }

  mounted() {
    this.$bvModal.show('uchicago-summer-modal');
  }

  handleContinueClicked() {
    this.$refs.modal.hide();
  }
}
</script>

<style lang="scss" scoped>
</style>
